import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { PaymentStatus } from "../../types";

interface PaymentProcessingState {
  status: PaymentStatus;
  error?: string;
}

const initialState: PaymentProcessingState = {
  status: PaymentStatus.Idle,
  error: undefined,
};

const paymentProcessingSlice = createSlice({
  name: "licensing/payment/processing",
  initialState,
  reducers: {
    startPayment(state: PaymentProcessingState) {
      state.status = PaymentStatus.Loading;
      state.error = undefined;
    },
    gotPayment(state: PaymentProcessingState, _action: PayloadAction<any>) {
      state.error = undefined;
    },
    errPayment(state: PaymentProcessingState, action: PayloadAction<string>) {
      state.status = PaymentStatus.Error;
      state.error = action.payload;
    },
    setPaymentSuccess(state: PaymentProcessingState) {
      state.status = PaymentStatus.Success;
      state.error = undefined;
    },
    resetPaymentError(state: PaymentProcessingState) {
      state.error = undefined;
      state.status = PaymentStatus.Idle;
    },
  },
});

export const { startPayment, gotPayment, errPayment, resetPaymentError, setPaymentSuccess } =
  paymentProcessingSlice.actions;

export default paymentProcessingSlice.reducer;
